import { Dialog } from '@material-ui/core';
import CashoutIcon from 'assets/images/CashoutIcon.svg?react';
import { DialogTypes } from 'features/eventLive/component/eventLiveCardView';
import { t } from 'i18next';
import Button from '../form/button';
import DialogCard from './dialogCard';

interface Props {
	handleDialogState: (param: DialogTypes, isOpen: boolean) => void;
	openCashoutInfo: boolean;
}

const CashoutAvaibleDialog = ({ openCashoutInfo, handleDialogState }: Props) => {
	return (
		<Dialog
			maxWidth="xs"
			fullWidth
			className="custom-dialog cashout bg--transparent custom--box-shadow text--center"
			aria-labelledby="customized-dialog"
			open={openCashoutInfo}
			onClose={() => handleDialogState('cashout', false)}
		>
			<DialogCard
				className="warning--card"
				icon={() => (
					<div className="cashout-dialog-icon-wrapper">
						<CashoutIcon className="cashout-dialog-icon" />
					</div>
				)}
				iconTitle={t('cashoutAvaible')}
				subDescription={t('cashoutDialogInfo')}
				showAmount={true}
				cardBottomCustom={
					<div className="card__bottom card__bottom_multi-btn">
						<Button
							className="card__bottom__btn"
							btnType="dialog-warning-accept"
							cyTestRef="yes-button"
							onClick={() => handleDialogState('cashout', false)}
						>
							{t('ok')}
						</Button>
					</div>
				}
			/>
		</Dialog>
	);
};

export default CashoutAvaibleDialog;
